export default __webpack_public_path__ + "static/media/wf_icon_large.fdc13586.svg";